import TopNav from "@/pages/home/components/TopNav";
import Hero from "@/pages/home/components/Hero";
import LiveTicker from "@/pages/home/components/LiveTicker";
import TopicWall from "@/pages/home/components/TopicWall";
import SceneRecord from "@/pages/home/components/SceneRecord";
import CrowdReaction from "@/pages/home/components/CrowdReaction";
import EventTimeline from "@/pages/home/components/EventTimeline";
import TrustFaq from "@/pages/home/components/TrustFaq";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <TopNav />
      <main>
        <Hero />
        <LiveTicker />
        <TopicWall />
        <SceneRecord />
        <CrowdReaction />
        <EventTimeline />
        <TrustFaq />
      </main>
      <Footer />
    </div>
  );
}